import I18n from 'I18n';
import { extractFQNFromAppPermissionName, getIsAppObjectAppPermission } from '../../utils/appObjectAppPermission';
const extractActionFromAppPermissionName = appPermissionName => {
  if (!getIsAppObjectAppPermission(appPermissionName)) {
    return '';
  }
  const parts = appPermissionName.split('.');
  // For schema properties.write, we want to return "properties.write"
  // For regular actions like read/write/create, we want just that part
  return parts.slice(4).join('.');
};
const extractRawAppObjectNameFromAppPermissionName = appPermissionName => {
  const FQN = extractFQNFromAppPermissionName(appPermissionName);

  // Extract everything after the underscore
  const underscoreIndex = FQN.indexOf('_');
  if (underscoreIndex === -1) {
    return '';
  }
  return FQN.slice(underscoreIndex + 1);
};
export const getAppObjectAppPermissionDescription = (name, appFQNToNameMap) => {
  var _appFQNToNameMap$extr;
  const appObjectScopeGroupType = extractActionFromAppPermissionName(name);
  const extractedAppObjectName = (_appFQNToNameMap$extr = appFQNToNameMap[extractFQNFromAppPermissionName(name)]) !== null && _appFQNToNameMap$extr !== void 0 ? _appFQNToNameMap$extr : extractRawAppObjectNameFromAppPermissionName(name);
  const unknownValue = extractedAppObjectName ? I18n.text('developer-experience-shared-components.scopes.appObjectScopeGroups.unknown', {
    objectName: extractedAppObjectName
  }) : undefined;
  return I18n.text(`developer-experience-shared-components.scopes.appObjectScopeGroups.${appObjectScopeGroupType}`, {
    objectName: extractedAppObjectName,
    defaultValue: unknownValue
  });
};